import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import DefaultButton from '../../../../../global/default-button/default-button';
import { withViewModel } from '../../../../../../infrastructure/components/with-view-model';
import { CreateLinkType, LinksViewModel, MAX_LINK_NUMBER } from './links.viewmodel';
import { ILinkDTO } from '../../../../../../api/meetings.dao';
import { makeLinkFormInPopover } from './make-link-form-in-popover';
import { LinkItem } from './link-item/link-item';
import './links.scss';

type Props = {
    vm: LinksViewModel;
};

export const OpenFormInPopOverBtn = makeLinkFormInPopover(
    React.forwardRef((props: { isOpen: boolean }, ref: React.Ref<HTMLInputElement>) => {
        return <DefaultButton
            ref={ref}
            text={<FormattedMessage id='oe.common.addEventLink' description='button label' defaultMessage='+ Add Link' />}
            className={classnames('event_form__items-section__add-button', { 'active': props.isOpen })}
        />;
    })
);

export const LinksView = observer((props: Props): JSX.Element => {
    const { vm } = props;

    const getLinks = (links: ILinkDTO[]) => {
        return links.map((link, index) => <LinkItem
            key={index}
            onDelete={() => vm.onDeleteLink(link)}
            vm={vm}
            isMeetingLink
            {...link}
        />
        );
    };

    return (
        <div className='event_form__items-section' >
            {<div className='event_form__items-section__title'>
                <FormattedMessage id='oe.meeting.links' description='Title text' defaultMessage='Links' />
            </div>
            }
            <div className='event_form__items-section__selected-items'>
                { !vm.links.length && !vm.getAddedLinks().length
                    && <div className='event_form__items-section__message'>
                        <FormattedMessage
                            id='oe.meeting.noLinks'
                            description='Placeholder text'
                            defaultMessage='Meeting has no assigned links'
                        />
                    </div>
                }
                {getLinks(vm.links.concat(vm.getAddedLinks()))}
            </div>
            <div>
                {((vm.links.length + vm.getAddedLinks().length) < MAX_LINK_NUMBER) &&
                    <OpenFormInPopOverBtn
                        onApply={async (link: CreateLinkType) => vm.onAddLink(link)}
                    />
                }
            </div>

        </div>
    );
});

type ContainerProps = {
    links: ILinkDTO[];
    accountId: number;
    eventId: number;
    meetingId: number;
    setAddedLinks: (link: ILinkDTO) => void; // []
    removeAddedLinks: (links: ILinkDTO) => void; // []
    getAddedLinks: () => ILinkDTO[];
};
const LinksContainer = withViewModel(LinksView, async (props: ContainerProps) => {
    return new LinksViewModel(props);
});

export { LinksContainer as Links };
